import { Component, Prop, Vue } from "vue-property-decorator";
import { Icon } from "ant-design-vue";
import { LessonPlanLocale } from "@/locales/localeid";
import { ComponentTaughtType, LessonPlanItemType } from "@/models/master-plan";

@Component({
	components: {
		"a-icon": Icon
	}
})
export default class TransitionCell extends Vue {
	@Prop({ default: false }) hasTransitionData!: boolean;
	@Prop({ default: [] }) sequences!: string[];

	get lessonPlanLocale(): any {
		return LessonPlanLocale;
	}

	onTransitionCellClicked() {
		this.$emit("click");
	}
}
